import { render, staticRenderFns } from "./socialLinks.vue?vue&type=template&id=df4a956a&scoped=true&"
import script from "./socialLinks.vue?vue&type=script&lang=js&"
export * from "./socialLinks.vue?vue&type=script&lang=js&"
import style0 from "./socialLinks.vue?vue&type=style&index=0&id=df4a956a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4a956a",
  null
  
)

export default component.exports